import { isMobile } from "app/assets/javascripts/utils/breakpoints"
import { ADS, adStatuses, currentRefreshInterval } from "./status"
import { googletag } from "./shared"

const displayAd = (ad, adStatus) => {
  const { id, shouldRefresh } = ad
  googletag.cmd.push(function () {
    googletag.display(id)

    googletag.pubads().addEventListener("impressionViewable", function (event) {
      const slot = event.slot

      if (!shouldRefresh || currentRefreshInterval === 0) {
        return
      }

      if (slot.getTargeting(id).indexOf("true") > -1) {
        console.log(`Queuing refresh for ${adStatus.activePath} of ${currentRefreshInterval}s`)
        setTimeout(function () {
          console.log(`Refreshing ${adStatus.activePath}`)
          googletag.pubads().refresh([slot])
        }, currentRefreshInterval * 1000)
      }
    })
  })
}

export const displayAds = () => {
  if (isMobile()) {
    Object.keys(ADS.mobile).forEach((key) => {
      if (adStatuses.mobile[key].initialized && !adStatuses.mobile[key].filled) {
        adStatuses.mobile[key].filled = true
        console.log("Displaying MOBILE AD:", key)
        displayAd(ADS.mobile[key], adStatuses.mobile[key])
      }
    })
  } else {
    Object.keys(ADS.desktop).forEach((key) => {
      if (adStatuses.desktop[key].initialized && !adStatuses.desktop[key].filled) {
        adStatuses.desktop[key].filled = true
        console.log("Displaying DESKTOP AD:", key)
        displayAd(ADS.desktop[key], adStatuses.desktop[key])
      }
    })
  }
}

displayAds()
